import React from 'react'

const Separator = ({ height = 20 }) => {
    return (
        <div style={{ height: height }}></div>
    )
}

export default Separator